import { HeaderStyled, Nav, Icon, Description, Theme } from "./styles"
import arrayIcons from "./icons"
import { useContext } from "react";
import { ThemeSiteContext } from "../../context/ThemeContext";


import sun from "../../assets/sun.png"
import moon from "../../assets/moon.png"


export default function Header(props) {

  const { theme } = useContext(ThemeSiteContext)


  return (
    <HeaderStyled id="header">

      <Theme    >

        <label
          htmlFor="choice">
          Temas

        </label>

        <span >
          <img src={moon} alt="sol" />
        </span>

        <input type="range"
          max="1"
          id="choice"
          onChange={theme.handleToggleTheme}
          value={theme.themeSite === "dark" ? 1 : 0}


        />

        <span  >
          <img src={sun} alt="sol" />
        </span>

      </Theme>



      <Nav>

        <ul>
          {arrayIcons.map(icons => <Icon
            key={icons.url}
            url={icons.url}
            href={icons.href}
            target="_blank"
            rel="noreferrer"
          >
            <li></li>

          </Icon>)}
        </ul>

        <Description>
          <h4>Olá, eu sou</h4>
          <h3>Wellington Eduardo</h3>
          <h1>desenvolvedor Full Stack</h1>
          <a
            href="https://wa.me/32984527181"
            target="_blank"
            rel="noreferrer"
          >
            <button>WhatsApp para contato</button>
          </a>
        </Description>

      </Nav>



    </HeaderStyled>

  );
}
